export enum ExportToCsvBHistory {
  Grid = 'Grid',
  Skipped = 'Skipped',
  Failed = 'Failed',
  Users = 'Users'
}
